import { createSelector } from 'reselect'

import userPrivateLibrariesSelector from 'redux/selectors/user/user_private_libraries_selector'
import viewTypes from 'helpers/enums/viewTypes'

const getExtraData = state => state.user.extra

const storeLockedContentSelector = createSelector(
	[ getExtraData, userPrivateLibrariesSelector ],
	(extraData, completeUserPrivateLibraries) => {

		const privateLibrariesFilter = [viewTypes.DISTRICT_LIBRARY]

		const privateLibrary = completeUserPrivateLibraries.find(library => privateLibrariesFilter.includes(library.library_type))

		return {
			districtLibraryId: privateLibrary ? privateLibrary.id : '',
			districtLibraryName: privateLibrary ? privateLibrary.name : '',
			isLoaded: !!extraData,
		}
	}
)

export default storeLockedContentSelector
